import React, { useEffect } from "react";
import Routers from "./router";

// External package
import AOS from "aos";
import "aos/dist/aos.css";

// Layout
import Navbar from "./layout/navbar";
import Footer from "./layout/footer";

// Helper
import validator from "./utils/helpers/validator";

function App() {
  useEffect(() => {
    // Initialize AOS
    AOS.init();

    // Setup mobile detection
    const cleanup = validator.validateIsMobileDevice(navigator.userAgent);

    // Cleanup function
    return () => {
      cleanup();
    };
  }, []);

  return (
    <div className="App bg-white-8">
      <div className="container">
        <Navbar />
        <Routers />
        <Footer />
      </div>
    </div>
  );
}

export default App;
